export enum HistoryActionTypes {
  ADD_TO_HISTORY = 'ADD_TO_HISTORY',
  SWITCH_HISTORY = 'SWITCH_HISTORY',
  UPDATE_CURRENT_HISTORY_INPUT_TYPE = 'UPDATE_CURRENT_HISTORY_INPUT_TYPE',
  UPDATE_CURRENT_HISTORY_RESULT_TYPE = 'UPDATE_CURRENT_HISTORY_RESULT_TYPE',
}
